// TODO: Deprecated, migrate to EmbedConfig or remove
import { z } from 'zod';
import { BlockType, FieldGroupSchema, FieldRole, PlainTextFieldSchema, UrlFieldSchema } from './Types';

const EmbeddedSnippetSnippetFieldSchema = UrlFieldSchema.extend({
  name: z.literal('embeddedSnippet'),
  role: z.literal(FieldRole.EmbeddedSnippet),
});
const EmbeddedSnippetHeaderFieldSchema = PlainTextFieldSchema.extend({
  name: z.literal('header'),
  role: z.literal(FieldRole.Header),
});

const EmbeddedSnippetFieldSchema = z.discriminatedUnion('name', [
  EmbeddedSnippetSnippetFieldSchema,
  EmbeddedSnippetHeaderFieldSchema,
]);

const EmbeddedSnippetFieldGroupSchema = FieldGroupSchema.extend({
  fields: z.array(EmbeddedSnippetFieldSchema),
});

export const EmbeddedSnippetBlockConfigSchema = z.object({
  options: z.record(z.string(), z.any()),
  type: z.literal(BlockType.EmbeddedSnippet),
  fieldGroups: z.tuple([EmbeddedSnippetFieldGroupSchema]),
  version: z.literal(2),
});
